module.exports = __webpack_public_path__ + "img/icono_2.bda177a9.svg";